<app-loader></app-loader>
<div class="container-fluid m-0 p-0 h-100">
  <!--Pre-logIn-->
  <div
    class="row m-0"
    [ngClass]="{
      layout:
        !isIdentityVerificationHandoff && !isPublicShellPage && !isAdminPage,
      'public-auth-layout': !isIdentityVerificationHandoff && isPublicShellPage,
      'identity-verification-layout': isIdentityVerificationHandoff,
      'admin-layout': isAdminPage
    }"
  >
    <app-landing-page-header
      class="public-auth-header"
      *ngIf="headerVariant === 'public'"
    ></app-landing-page-header>

    <!-- If not auth module -->
    <app-header
      class="layout-header"
      *ngIf="headerVariant === 'app' && !isAdminPage"
    ></app-header>

    <header class="admin-header" *ngIf="isAdminPage">
      <a
        routerLink="/dashboard"
        class="admin-header__brand"
        (click)="closeAdminMenus()"
        aria-label="CitizeX admin dashboard"
      >
        <img src="/assets/images/logo-text.png" alt="CitizeX" />
      </a>
      <button
        type="button"
        class="admin-header__menu-toggle"
        [attr.aria-expanded]="adminMenuOpen"
        aria-controls="admin-sidebar"
        (click)="adminMenuOpen = !adminMenuOpen; adminAccountOpen = false"
        [attr.aria-label]="
          adminMenuOpen ? 'Close admin menu' : 'Open admin menu'
        "
      >
        <app-icon
          [name]="adminMenuOpen ? 'x' : 'menu'"
          aria-hidden="true"
        ></app-icon>
      </button>
      <div class="admin-header__account-wrap">
        <button
          type="button"
          class="admin-header__avatar"
          [attr.aria-expanded]="adminAccountOpen"
          aria-label="Admin account"
          (click)="adminAccountOpen = !adminAccountOpen"
        >
          <img src="/assets/images/noprofile2.png" alt="" />
        </button>
        <div class="admin-account-menu" *ngIf="adminAccountOpen">
          <div class="admin-account-menu__identity">
            <strong>{{ adminDisplayName }}</strong
            ><small *ngIf="adminUser?.userName"
              >&#64;{{ adminUser.userName }}</small
            >
          </div>
          <a routerLink="/portal" (click)="closeAdminMenus()">
            <app-icon name="globe" aria-hidden="true"></app-icon>View user
            portal
          </a>
          <button type="button" (click)="adminLogOut()">
            <app-icon name="log-out" aria-hidden="true"></app-icon>Log out
          </button>
        </div>
      </div>
    </header>

    <nav
      id="admin-sidebar"
      class="admin-sidebar"
      *ngIf="isAdminPage"
      [class.admin-sidebar--open]="adminMenuOpen"
      aria-label="Admin navigation"
    >
      <div class="admin-sidebar__identity">
        <img src="/assets/images/noprofile2.png" alt="" />
        <span
          ><strong>{{ adminDisplayName }}</strong
          ><small *ngIf="adminUser?.userName"
            >&#64;{{ adminUser.userName }}</small
          ></span
        >
      </div>
      <div class="admin-sidebar__group" *ngFor="let group of adminNav">
        <div class="admin-sidebar__label">{{ group.label }}</div>
        <a
          *ngFor="let item of group.items"
          [routerLink]="item.path"
          [class.admin-sidebar__link--active]="isAdminNavActive(item.path)"
          class="admin-sidebar__link"
          (click)="closeAdminMenus()"
        >
          <app-icon [name]="item.icon" aria-hidden="true"></app-icon
          ><span>{{ item.label }}</span>
        </a>
      </div>
      <!-- Mobile only: the header account menu is hidden on small screens. -->
      <a
        routerLink="/portal"
        class="admin-sidebar__account-link"
        (click)="closeAdminMenus()"
      >
        <app-icon name="globe" aria-hidden="true"></app-icon>View user portal
      </a>
      <button
        type="button"
        class="admin-sidebar__logout"
        (click)="adminLogOut()"
      >
        <app-icon name="log-out" aria-hidden="true"></app-icon>Log out
      </button>
    </nav>
    <button
      *ngIf="isAdminPage && adminMenuOpen"
      type="button"
      class="admin-sidebar-backdrop"
      aria-label="Close admin menu"
      (click)="adminMenuOpen = false"
    ></button>

    <!-- Content -->
    <section
      [ngClass]="{
        'public-page-content':
          !isIdentityVerificationHandoff && isPublicShellPage,
        'public-discovery-content':
          !isIdentityVerificationHandoff &&
          isPublicShellPage &&
          isPublicContentPage,
        'public-auth-content':
          !isIdentityVerificationHandoff && isPublicAuthPage,
        'layout-content':
          !isIdentityVerificationHandoff && !isPublicShellPage && !isAdminPage,
        'event-landing-content': isEventLandingPage && !isPublicShellPage,
        'identity-verification-content': isIdentityVerificationHandoff,
        'admin-page-content': isAdminPage
      }"
    >
      <div
        [ngClass]="{
          'site-content-container public-auth-route': isPublicAuthPage,
          'public-page-route':
            isPublicShellPage && !isPublicAuthPage && !isLandingPage
        }"
      >
        <router-outlet></router-outlet>
      </div>
    </section>

    <app-landing-page-footer
      class="public-auth-footer"
      *ngIf="
        !isIdentityVerificationHandoff &&
        isPublicShellPage &&
        isInitialNavigationComplete
      "
    ></app-landing-page-footer>

    <app-landing-page-footer
      class="layout-footer"
      *ngIf="
        !isIdentityVerificationHandoff &&
        !isPublicShellPage &&
        !isLandingPage &&
        !isAdminPage
      "
    ></app-landing-page-footer>
  </div>

  <app-help-bot
    class="app-help-bot"
    *ngIf="getUserLoggedIn() && !isIdentityVerificationHandoff && !isAdminPage"
  ></app-help-bot>
</div>

<app-cookie-consent></app-cookie-consent>
